import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum AddonProduct {
  MOOD = "MOOD",
  CLINICAL = "CLINICAL",
}

export interface PaymentAddonState {
  addon_product_id?: string;
  description?: string;
  discount?: number;
  image_name?: string;
  is_free?: boolean;
  is_free_shipping?: boolean;
  is_sold_out?: boolean;
  label?: string;
  per_month?: boolean;
  price?: number; // Price without taxes
  regular_price?: number;
  sale_item_id?: string;
  shipping_address_required?: boolean;
  title?: string;
  type?: "subscription" | "bundle" | "transaction";
  sales_tax_amount?: number;
  sales_tax_rate?: number;
  is_tax_inclusive?: boolean;
  product_type?: AddonProduct;
  hasOffer: boolean;
  isDiscounted: boolean;
}

const paymentAddonSlice = createSlice({
  name: "paymentAddon",
  initialState: {
    hasOffer: false,
    isDiscounted: false,
    sales_tax_amount: 0,
    sales_tax_rate: 0,
  } as PaymentAddonState,
  reducers: {
    updatePaymentAddon(
      state,
      action: PayloadAction<Partial<Omit<PaymentAddonState, "hasOffer">>>
    ) {
      return { ...state, ...action.payload };
    },
  },
});

export const getAddOnTotalPrice = (
  paymentAddon: Partial<PaymentAddonState>
) => {
  if (!paymentAddon?.price) {
    return 0;
  }

  return paymentAddon.is_tax_inclusive
    ? paymentAddon.price
    : paymentAddon.price + paymentAddon.sales_tax_amount;
};

export const getTotalPriceWithPlan = (
  paymentAddon: Partial<PaymentAddonState>,
  planPrice: number
) => {
  return getAddOnTotalPrice(paymentAddon) + planPrice;
};

export const getTotalSalesTaxWithPlan = (
  paymentAddon: Partial<PaymentAddonState>,
  planSalesTaxAmount: number
) => {
  if (!paymentAddon?.sales_tax_amount) {
    return planSalesTaxAmount;
  }

  return paymentAddon.sales_tax_amount + planSalesTaxAmount;
};

export const { updatePaymentAddon } = paymentAddonSlice.actions;

export default paymentAddonSlice;
